import React, { forwardRef, useEffect, useLayoutEffect, useRef } from 'react';
import { backdropClasses } from '@mui/material';

import { RootContainers } from '@/modules/common/helpers';
import { omitUndefinedProps } from '@/mui/helpers';

const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

// let paddingRight: string | undefined;
// let overflow: string | undefined;

const Backdrop = forwardRef<HTMLDivElement>((props, ref) => {
  const innerRef = useRef<HTMLDivElement>(null);
  useIsomorphicLayoutEffect(() => {
    const { width: beginningWidth } = document.body.getBoundingClientRect();

    document.body.style.overflow = 'hidden';

    const { width: updatedWidth } = document.body.getBoundingClientRect();

    const { direction } = window.getComputedStyle(document.body);
    const paddingDelta = Math.max(0, updatedWidth - beginningWidth);
    const directionPaddingKey = direction === 'rtl' ? 'paddingLeft' : 'paddingRight';

    document.body.style[directionPaddingKey] = `${paddingDelta}px`;

    return () => {
      const backdropList = Array.from(
        RootContainers.getMUIPortalContainer().querySelectorAll(`.${backdropClasses.root}`),
      );

      const destroyMarker = 'data-unmount-component';

      backdropList.forEach((el) => {
        if (innerRef.current === el) {
          el.setAttribute(destroyMarker, '');
        }
      });

      if (backdropList.filter((node) => node.hasAttribute(destroyMarker)).length <= 1) {
        document.body.style[directionPaddingKey] = '';

        document.body.style.overflow = '';
      }
    };
  }, []);

  return (
    <div
      {...omitUndefinedProps(props)}
      ref={(node) => {
        if (typeof ref === 'function') {
          ref(node);
        } else if (ref) {
          ref.current = node;
        }

        innerRef.current = node;
      }}
    />
  );
});

Backdrop.displayName = 'Backdrop';

export default Backdrop;
